import { UserType } from './../../index';
import me from './me';
import get from './get';
import id from './{id}';
import phoneinfo from './phoneinfo';
import unimpersonate from './unimpersonate';
import query from './query';

export type PostPayload = {
  email?: string;
  folders: number[];
  information?: UserType['information'];
  isRoot?: boolean;
  phone: string;
  preferences: object;
  roleId: number;
};

export default { me, get, id, phoneinfo, unimpersonate, query };
